module.exports = __webpack_public_path__ + "img/service-dashujuzhengxin2.77473ef4.svg";